import { render } from "./ProductSegmentCreate.vue?vue&type=template&id=14d5630e&scoped=true"
import script from "./ProductSegmentCreate.vue?vue&type=script&lang=js"
export * from "./ProductSegmentCreate.vue?vue&type=script&lang=js"

import "./ProductSegmentCreate.vue?vue&type=style&index=0&id=14d5630e&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d5630e"]])

export default __exports__